import Vue from "vue";

export class CaixaPacPon {
    static create() {
        return {
            fibra: {
                _id: null,
                numero: null
            },
            porta_pon: {
                _id: null,
                nome: null
            },
            cto: {
                _id: null,
                numero: null
            },
            modelo_switch: {
                _id: null,
            },
            vlan: null,
            limite_banda: 300,
            place: [0, 0],
            numero: null,
            obs: null,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-pacpon/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byCTO(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-pacpon/by-cto/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("caixa-pacpon/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static criarOrdem(id) {
        return Vue.http.post("caixa-pacpon/ordem/" + id, {});
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-pacpon")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static offline() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-pacpon/offline")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allSemVlan() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-pacpon/relatorio/sem-vlan")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allProblemasSinal() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-pacpon/problemas/sinal")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allSemOnuMac() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-pacpon/relatorio/sem-onuid")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("caixa-pacpon/" + data._id, data);
            } else {
                promisse = Vue.http.post("caixa-pacpon/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
